if (!customElements.get('sa-bestsellers-rail')) {
  customElements.define('sa-bestsellers-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.sa-bestsellers__products');
      this.controls = this.querySelector('.sa-bestsellers__controls');
      if (!this.rail || !this.controls || this.abort) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.previous = this.controls.querySelector('[data-direction="previous"]');
      this.next = this.controls.querySelector('[data-direction="next"]');
      this.controls.hidden = false;
      const move = direction => this.rail.scrollBy({
        left: direction * this.rail.clientWidth,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.previous.addEventListener('click', () => move(-1), { signal });
      this.next.addEventListener('click', () => move(1), { signal });
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      const update = () => {
        this.previous.disabled = this.rail.scrollLeft < 2;
        this.next.disabled = this.rail.scrollLeft >= this.rail.scrollWidth - this.rail.clientWidth - 2;
      };
      this.rail.addEventListener('scroll', update, { passive: true, signal });
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.rail);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
    }
  });
}
